module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("“I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRIKING")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNSYLVANIA")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "titlea"
  }, [_vm._v("The Army of Northern Virginia and the Army of the Potomac March to Gettysburg")]), _vm._v(" "), _c('p', {
    staticClass: "titleaa"
  }, [_vm._v("Volume 2: June 22–30, 1863")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("SCOTT L. MINGUS Sr.")]), _vm._v(" "), _c('p', {
    staticClass: "authora"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("and")]), _vm._v(" ERIC J. WITTENBERG")]), _vm._v(" "), _c('div', {
    staticClass: "image_containerf"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/logo.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-654e8336","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Title.vue
// module id = 57
// module chunks = 0